import {
  adminInput,
  adminButtonPrimary,
  adminSectionTitle,
  adminModalPanel,
} from '../../layout/adminStyles';
import React, { FC, FormEvent } from 'react';
import { CategoryForm } from './categoryForm';

type Props = {
  isShowModal: boolean;
  categoryId: number | null;
  form: CategoryForm;
  isSaving: boolean;
  onChange: (form: CategoryForm) => void;
  onClose: () => void;
  onSubmit: () => void;
};

const CategoryEditModal: FC<Props> = ({
  isShowModal,
  categoryId,
  form,
  isSaving,
  onChange,
  onClose,
  onSubmit,
}) => {
  if (!isShowModal || categoryId == null) {
    return null;
  }

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="category-edit-modal-title"
    >
      <div className={adminModalPanel}>
        <div className="mb-4 flex items-center justify-between border-b border-stone-200 pb-3">
          <h2 id="category-edit-modal-title" className={adminSectionTitle + ' mb-0 border-0 pb-0'}>
            カテゴリ編集
          </h2>
          <button
            type="button"
            className="text-2xl leading-none text-stone-500 hover:text-stone-800"
            onClick={onClose}
            aria-label="閉じる"
          >
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="mb-1 block text-sm font-medium text-stone-700">ID</label>
            <p className="text-stone-800">{categoryId}</p>
          </div>

          <div className="mb-4">
            <label htmlFor="edit-category-name" className="mb-1 block text-sm font-medium text-stone-700">
              カテゴリ名
            </label>
            <input
              id="edit-category-name"
              type="text"
              required
              className={`${adminInput} w-full`}
              value={form.name}
              onChange={(e) => onChange({ ...form, name: e.target.value })}
            />
          </div>

          <div className="mb-6">
            <label htmlFor="edit-category-display-order" className="mb-1 block text-sm font-medium text-stone-700">
              表示順
            </label>
            <input
              id="edit-category-display-order"
              type="number"
              required
              className={`${adminInput} w-full`}
              value={form.display_order}
              onChange={(e) => onChange({ ...form, display_order: e.target.value })}
            />
          </div>

          <div className="flex justify-end gap-2">
            <button
              type="button"
              className="rounded-xl border border-stone-300 px-5 py-2 text-stone-700 hover:bg-stone-50"
              onClick={onClose}
              disabled={isSaving}
            >
              キャンセル
            </button>
            <button type="submit" className={adminButtonPrimary} disabled={isSaving}>
              {isSaving ? '保存中...' : '保存'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoryEditModal;
